module.exports = __webpack_public_path__ + "static/single-task-2cf49b104f73011590e9117355bc8153.png";